'use strict';

import Constants from '../constants.js';
import ObjectAssign from 'object-assign';

const initialState = {
    hydrated: false,
    loading: false,
    error: undefined,
    hasError: {},
    help: {},
    client: undefined
};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.RESET_BT_CLIENT) {

        return ObjectAssign({}, initialState);
    }

    if (action.type === Constants.CREATE_BT_CLIENT) {

        return ObjectAssign({}, state, {
            loading : true,
            hydrated : false
        });

    }

    if (action.type === Constants.CREATE_BT_CLIENT_RESULT) {

        if ( !action.err) {
            return ObjectAssign({}, state, {
                client : action.client,
                loading: false,
                hydrated: true
            });
        }

        return ObjectAssign({}, state, {
            client: undefined,
            error : action.err
        });
    }

    return state;
};


export default reducer;
